export default {
    events: [
        {
            name: 'cell.click',
            desc: 'trigger when user clicks a table cell',
        },
    ],
};
